import { selectPeers, useHMSStore } from "@100mslive/react-sdk";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { SIDE_PANES, useSidePane } from "@/hooks/useSidePane";
import { isInternalRole } from "@/lib/roles";

/** The top of the side pane: People and Chat side by side (Cal.com's), and close. */
export const SidePaneHeader = ({ closeLabel, closeTestId, onClose }) => {
  const { sidePane, setSidePane } = useSidePane();
  const peopleCount = useHMSStore(selectPeers).filter(
    peer => !isInternalRole(peer.roleName)
  ).length;
  return (
    <div className="flex items-center justify-between gap-2 border-b px-3 py-2">
      <ToggleGroup
        type="single"
        size="sm"
        value={sidePane || ""}
        onValueChange={value => value && setSidePane(value)}
        aria-label="Side pane"
        className="rounded-lg bg-muted p-0.5"
      >
        <ToggleGroupItem
          value={SIDE_PANES.participants}
          data-testid="people_tab"
          className="h-7 gap-1.5 rounded-md px-3 first:rounded-md last:rounded-md data-[state=on]:bg-card data-[state=on]:text-foreground data-[state=on]:shadow-xs"
        >
          People
          <span className="text-muted-foreground tabular-nums">
            {peopleCount}
          </span>
        </ToggleGroupItem>
        <ToggleGroupItem
          value={SIDE_PANES.chat}
          data-testid="chat_tab"
          className="h-7 rounded-md px-3 first:rounded-md last:rounded-md data-[state=on]:bg-card data-[state=on]:text-foreground data-[state=on]:shadow-xs"
        >
          Chat
        </ToggleGroupItem>
      </ToggleGroup>
      <Button
        size="icon-sm"
        variant="ghost"
        aria-label={closeLabel}
        data-testid={closeTestId}
        onClick={onClose}
      >
        <X />
      </Button>
    </div>
  );
};
